/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 13:11:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/PageSetting/index.tsx
 */

import React from 'react';

//import css from './css.less';
import Info from 'src/constrains/SalesChannelPreviewPageComponents/MiniProgramPageInfo';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getGeneralMiniProgramPageInfo,
  onCollapseOpen,
  onErrorChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

const MiniProgramShare = (props) => {
  const { data } = props;

  // const _d = useDispatch();

  const { miniProgramPath, miniProgramAppId, qrCodeUrl } = data || {};

  // const handleOnImageChange = (image) => {
  //   _d(onMiniProgramShareChange({ shareCoverImage: image }));
  // };

  // const handleOnTitleChange = (shareTitle) => {
  //   _d(onMiniProgramShareChange({ shareTitle }));
  // };

  return (
    <React.Fragment>
      <Info
        miniProgramPath={miniProgramPath}
        miniProgramAppId={miniProgramAppId}
        qrCodeUrl={qrCodeUrl}
        // image={shareCoverImage}
        // text={shareTitle}
        // onImageChange={handleOnImageChange}
        // onTextChange={handleOnTitleChange}
      />
      {/* <Section bottomBorder={!hideTimeSelect}>
        <ItemWrapper title='Page Name'>
          <Input
            error={display && (nameError || []).length > 0}
            help={(nameError || []).join(' ')}
            maxLength={100}
            size='large'
            value={name}
            onChange={handleOnNameChange}
          />
        </ItemWrapper>
      </Section>
      {!hideTimeSelect && (
        <Section>
          <TimeAndDatePickerWithAlwaysOn
            data={{
              startTime: _startTime,
              endTime: _endTime,
              alwaysOn: alwaysOn,
            }}
            onTypeChange={handleOnTypeChange}
            onDateChange={handleOnTimeChange}
            error={
              display && (timePickerError || []).length > 0
                ? (timePickerError || []).join(' ')
                : false
            }
            timezone={timezoneInGmt}
          />
        </Section>
      )} */}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MiniProgramShare, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.miniProgramPageInfo,
  getContent: getGeneralMiniProgramPageInfo,
  title: getI18nFromGeneral('general.hOCTitle.miniProgramPageInformation'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //   validation: (x, validationProps) => {
  //     const { isPrimary } = validationProps || {};

  //     return validatePageSetting(x, !isPrimary);
  //   },
  //   getSubmitStamp,
});
